import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Amplify from "aws-amplify";
import awsconfig from "./aws-exports";
import vuetify from "./plugins/vuetify";
import VuetifyDialog from "vuetify-dialog";
import 'vuetify-dialog/dist/vuetify-dialog.css';
import JsonViewer from 'vue-json-viewer';
import VueTimeago from 'vue-timeago';
// Main JS (in UMD format)
import VueTimepicker from 'vue2-timepicker'
import DatetimePicker from 'vuetify-datetime-picker'

// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'


Amplify.configure(awsconfig);

Vue.prototype.$Amplify = Amplify;

Vue.use(VuetifyDialog, {
  context: {
      vuetify
  }
});

Vue.use(VueTimeago, {
  locale: 'en-AU'
});

Vue.use(VueTimepicker);

Vue.use(JsonViewer);

Vue.use(DatetimePicker)

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
